import { Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { usePlatformAdmin } from "@/providers/platform-admin-provider";
import { WorkspaceLayout } from "@/components/workspace-layout";
import { PageTitleProvider } from "@/contexts/page-title-context";
import { platformAdminNavigation } from "@root/config/navigation";

export function PlatformAdminProtectedLayout() {
  const { loading, admin, logout } = usePlatformAdmin();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !admin) {
      navigate("/platform-admin/login", { replace: true });
    }
  }, [loading, admin, navigate]);

  if (loading) {
    return (
      <div className="platform-admin-surface">
        <div className="flex min-h-screen items-center justify-center">
          <div className="h-12 w-12 animate-spin rounded-full border-4 border-[#d9c7ae] border-t-[#8b7355]" />
        </div>
      </div>
    );
  }

  if (!admin) {
    return null;
  }

  const handleLogout = async () => {
    await logout();
    navigate("/platform-admin/login", { replace: true });
  };

  return (
    <PageTitleProvider>
      <WorkspaceLayout
        userName={admin?.name}
        onLogout={handleLogout}
        sections={platformAdminNavigation}
        menuVariant="platform"
      >
        <Outlet />
      </WorkspaceLayout>
    </PageTitleProvider>
  );
}
